<template>
    <div>
        <el-dialog class="rule-dialog" :visible="isShow" custom-class="registerDialog" :show-close=false>
            <div slot="title" style="height:50px;text-align:left;font-weight:600;">
                <p>尊敬的一链网用户：</p>
                <p style="text-indent: 2em;">一链网自2020年1月10日更新《一链网隐私策略》，请您仔细阅读后并点击【同意】继续操作，以下为《一链网隐私策略》内容：</p>
            </div>
                <div style="max-height: 450px; overflow-x:hidden;" id="alert-box2" class="alert-box layui-layer-wrap">
                    <p>本用户隐私保护政策(以下简称“本政策”)旨在向一链网用户说明复星对用户隐私保护的管理构架，以及对用户个人信息收集、使用和管理的基本方式。一链网是复星旗下的孵化项目，复星的用户隐私保护政策同样适用于一链网的用户。</p>
                    <h5>一、一链网如何收集和使用您的个人信息</h5>
                    <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
                    <p>在您使用一链网的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息主要包括如下目的:</p>
                    <p>我们将收集您的个人信息用于以下两项用途，若我们超过以下用途使用您的信息，我们将再次向您说明，并征得您的同意。</p>
                    <p>1、为实现向您提供一链网的产品及/或服务的基本功能。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务;</p>
                    <p>2、为实现向您提供一链网的产品及/或服务的附加功能。如您拒绝提供，您将无法正常使用相关附加功能，但并不会影响您正常使用我们的产品及/或服务的基本功能。</p>
                    <h5>二、我们如何共享、转让、公开披露您的个人信息</h5>
                    <p>(一)共享</p>
                    <p>我们不会向其他任何公司、组织和个人分享您的个人信息，但以下情况除外:</p>
                    <p>1、在获取明确同意的情况下共享:获得您的明确同意后，我们会与其他方共享您的个人信息;</p>
                    <p>2、在法定情形下的共享:我们可能会根据法律法规规定，或按政府主管部门的要求，对外共享您的个人信息;</p>
                    <p>3、与复星体系内控股企业共享:为便于我们向您提供更优质的产品和服务，识别您的个人信息的异常使用情况，保护复星体系内的企业及公众的人身财产安全免遭侵害，您的个人信息可能会与复星体系内控股企业共享。我们只会共享必要的个人信息，且受本政策中所声明目的的约束，如果我们共享您的个人敏感信息或共享的企业改变个人信息的使用及处理目的，将再次征求您的授权同意;</p>
                    <p>4、与授权合作伙伴共享:我们的某些服务将由授权合作伙伴提供。为了能提供更好的客户服务和用户体验，我们可能会与合作伙伴共享您的某些个人信息。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，授权合作伙伴只能接触到其履行职责所需要的信息，且不得将此信息用于其他任何目的。</p>
                    <p>对我们与之共享个人信息的公司、组织和个人，我们会要求他们按照本政策以及其他我们要求其遵守的不低于本政策要求的保密和安全措施来处理个人信息。</p>
                    <p>(二)转让</p>
                    <p>我们不会将您的个人信息转让给其他任何公司、组织和个人，但以下情况除外:</p>
                    <p>1、在获取明确同意的情况下转让:获得您的明确同意后，我们会向其他方转让您的个人信息;</p>
                    <p>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
                    <p>(三)公开披露</p>
                    <p>我们仅会在以下情况下，公开披露您的个人信息:</p>
                    <p>1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息;</p>
                    <p>2、基于法律的披露:在法律、行政或司法程序、诉讼或政府主管部门强制性要求的情况下,我们可能会公开披露您的个人信息。</p>
                    <h5>三、我们如何保护您的个人信息</h5>
                    <p>1、我们已采取符合业界标准、合理可行的安全防护措施保护您的个人信息，防止您的个人信息遭到未经授权的访问、披露、使用、修改、损坏或丢失。例如，我们对我们网站提供https 安全浏览方式;我们会使用加密技术(例如SSL)确保数据的保密性;我们会使用受信赖的保护机制防止数据遭到恶意攻击;我们会部署访问控制机制，确保只有授权人员才可访问用户个人信息;以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
                    <p>2、如果发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知:安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照政府主管部门的要求，主动上报个人信息安全事件的处置情况。</p>
                    <h5>四、未成年人保护</h5>
                    <p>我们重视未成年人的信息保护，如您为未成年人的，建议您请您的父母或监护人仔细阅读本政策，并在征得您的父母或监护
            人同意的前提下使用我们的服务或向我们提供信息。我们将根据国家相关法律法规保护未成年人的个人信息。</p>
                    <h5>五、本政策的适用范围</h5>
                    <p>信息存储:一链网在中华人民共和国(“中国”)境内运营中收集和产生的个人信息将存储在中国，我们会确保依据本政策对您的个人信息提供足够的保护。</p>
                    <p>法律适用:一链网同时遵从全球各地适用的隐私法律，包括但不限于GDPR，一链网将确保全球范围内开展的相关业务遵从并适用各地的法律法规要求。</p>
                    <h5>六、本政策如何更新</h5>
                    <p>我们可能适时的会对本政策进行调整或变更，本政策的任何更新将以标注更新时间的方式公布在复星的官方网站上，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的七日后生效。</p>
                    <h5>七、联系我们</h5>
                    <p>您的意见，对我们非常重要。如果您对本政策有任何疑问、意见或建议，或是发现个人信息可能被泄露，您可以通过复星官方的客户投诉渠道联系我们:</p>
                    <p>客户投诉网站:https://contact.fosun.com/complaint 客户投诉邮箱:groupcst@fosun.com</p>
                    <p>本政策更新时间：2020年1月10日</p>
                </div>
                <template #footer>
                    <el-button type="primary"  @click="sure">同 意</el-button>
                    <el-button @click="closeDialog">不同意并退出</el-button>
                </template>
            </el-dialog>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import { mapState, mapMutations } from 'vuex'
    export default {
        name: 'PrivacyPolicy',

        props: {
            isShow: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                
            }
        },

        computed: mapState([
          'KP',
          'leadSteps'
        ]),

        methods: {
            ...mapMutations([
              'modifyLeadStep',
            ]),
            closeDialog() {
                this.$emit('closed');
                this.loginOut();
            },
            sure() {
                this.$axios.post('/onelink.mdata.main.api/web/operatePrivacyPolicy').then((res) => {
                    let { code } = res.data;
                    if(code == 0) {
                        this.setToken('privacyPolicyFlag', 0);
                        this.$emit('closed', 1);
                    }
                })
            },
            loginOut() {
                this.$axios.post('/onelink.mdata.main.api/user/loginOut', {
                }).then((res) => {
                    this.data = res.data;
                    let logoutFlag = this.data.loginOutFlag;
                    if(logoutFlag) {
                        this.removeToken('isLogin');
                        this.removeToken('userInfo');
                        this.removeToken('companyInfo');
                        this.removeToken('checkFlag');
                        this.removeToken('examineStatus');
                        this.removeToken('exmaineMessage');
                        this.removeToken('noticeInfos');
                        this.removeToken('userTag');
                        this.removeToken('coordinationSupplierAuthFlag');
                        this.removeToken('coordinationSystemAuthFlag');
                        this.removeToken('messageNumber');
                        this.removeToken('supplierManagerAuthFlag');
                        this.removeToken('isCompanyManager');
                        this.removeToken('privacyPolicyFlag');

                        Cookies.remove('isLogin');
                        Cookies.remove('userInfo');
                        Cookies.remove('companyInfo');
                        Cookies.remove('checkFlag');
                        Cookies.remove('examineStatus');
                        Cookies.remove('exmaineMessage');
                        this.setToken('privacyPolicyFlag', 1);
                        // 退出后关闭新手引导弹框
                        this['modifyLeadStep']({
                          maskStep: true,
                          thirdStep: false
                        })
                        this.$router.push({path:'/'});
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/privacyPolicy/index.vue